import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useAuth } from '../auth'
import { isTeamMemberWithoutLabPlus } from '../isTeamMember'
import { labSignInPath } from '../routeHelpers'

type UseTeamMemberLabPlusGuardOptions = {
  redirectTo?: string
}

export function useTeamMemberLabPlusGuard(
  options: UseTeamMemberLabPlusGuardOptions = {}
) {
  const { redirectTo = labSignInPath() } = options
  const router = useRouter()
  const { currentUser, isLoading } = useAuth()
  const isChecking = isLoading || !router.isReady
  const shouldBlock =
    !isChecking &&
    Boolean(currentUser && isTeamMemberWithoutLabPlus(currentUser))

  useEffect(() => {
    if (!shouldBlock) return

    router.replace(redirectTo)
  }, [shouldBlock, redirectTo, router])

  return {
    isBlocked: shouldBlock,
    isLoading: isChecking
  }
}
